// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
// import "bootstrap/dist/css/bootstrap.min.css";

// const Advertisement = () => {
//     const [category, setCategory] = useState("");
//     const [image, setImage] = useState(null);
//     const [advertisements, setAdvertisements] = useState([]);

//     // Fetch all advertisements
//     const fetchAdvertisements = async () => {
//         try {
//             const response = await axios.get("https://gwcapi.emedha.in/pages/api/api/advertisements");
//             setAdvertisements(response.data);
//         } catch (error) {
//             console.error("Error fetching advertisements:", error);
//         }
//     };

//     useEffect(() => {
//         fetchAdvertisements();
//     }, []);

//     // Handle File Upload
//     const handleImageChange = (e) => {
//         setImage(e.target.files[0]);
//     };

//     // Handle Form Submission (Add New Advertisement)
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!category || !image) {
//             alert("Please select a category and upload an image.");
//             return;
//         }

//         const formData = new FormData();
//         formData.append("category", category);
//         formData.append("image", image);

//         try {
//             await axios.post("https://gwcapi.emedha.in/pages/api/api/advertisements", formData, {
//                 headers: { "Content-Type": "multipart/form-data" },
//             });
//             alert("Advertisement added successfully!");
//             setCategory("");
//             setImage(null);
//             fetchAdvertisements();
//         } catch (error) {
//             console.error("Error adding advertisement:", error);
//         }
//     };

//     // Handle Delete Advertisement
//     const handleDelete = async (id) => {
//         if (window.confirm("Are you sure you want to delete this advertisement?")) {
//             try {
//                 await axios.delete(`https://gwcapi.emedha.in/pages/api/api/advertisements/${id}`);
//                 alert("Advertisement deleted!");
//                 fetchAdvertisements();
//             } catch (error) {
//                 console.error("Error deleting advertisement:", error);
//             }
//         }
//     };

//     return (
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Advertisement Management</h2>
//             {/* Form for Adding Advertisement */}
//             <form onSubmit={handleSubmit} className="card p-3 shadow">
//                 <div className="mb-3">
//                     <label className="form-label">Select Page Route</label>
//                     <select className="form-control" value={category} onChange={(e) => setCategory(e.target.value)}>
//                         <option value="">Select Route</option>
//                         <option value="advertise">Advertise Page</option>
//                         <option value="login">Login</option>
//                         <option value="signup">Signup</option>
//                         <option value="club">Club</option>
//                         <option value="member">Member</option>
//                         <option value="index">Index</option>
//                         <option value="welcome">Welcome</option>
//                     </select>
//                 </div>

//                 <div className="mb-3">
//                     <label className="form-label">Upload Image</label>
//                     <input type="file" className="form-control" onChange={handleImageChange} />
//                 </div>

//                 <button type="submit" className="btn btn-primary w-100">
//                     <FaPlus /> Add Advertisement
//                 </button>
//             </form>

//             {/* Display Advertisements */}
//             <div className="mt-4">
//                 <h4>Existing Advertisements</h4>
//                 <table className="table table-bordered table-hover">
//                     <thead className="table-dark">
//                         <tr>
//                             <th>#</th>
//                             <th>Category</th>
//                             <th>Image</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {advertisements.map((ad, index) => (
//                             <tr key={ad.id}>
//                                 <td>{index + 1}</td>
//                                 <td>{ad.category}</td>
//                                 <td>
//                                     <img src={`http://localhost:5000${ad.image_url}`} alt="Ad" width="80" height="50" />
//                                 </td>
//                                 <td>
//                                     <button className="btn btn-danger btn-sm" onClick={() => handleDelete(ad.id)}>
//                                         <FaTrash /> Delete
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default Advertisement;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { Pagination, Modal, Button, Navbar, Container, Image, Table } from "react-bootstrap";
import { IoReturnUpBack } from "react-icons/io5";
import Logo from "../Images/gd.png"; // Import your logo image
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const Advertisement = () => {
    const [category, setCategory] = useState("");
    const [image, setImage] = useState(null);
    const [advertisements, setAdvertisements] = useState([]);
    const [selectedAd, setSelectedAd] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5; // Number of items per page

    useEffect(() => {
        fetchAdvertisements();
    }, []);

    const fetchAdvertisements = async () => {
        try {
            const response = await axios.get("https://gwcapi.emedha.in/pages/api/api/advertisements");
            setAdvertisements(response.data);
        } catch (error) {
            console.error("Error fetching advertisements:", error);
        }
    };

    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
    };

    const openModal = (ad = null) => {
        if (ad) {
            setSelectedAd(ad);
            setCategory(ad.category);
        } else {
            setSelectedAd(null);
            setCategory("");
        }
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedAd(null);
        setCategory("");
        setImage(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!category) {
            alert("Please select a category.");
            return;
        }

        const formData = new FormData();
        formData.append("category", category);
        if (image) formData.append("image", image);

        try {
            if (selectedAd) {
                await axios.put(`https://gwcapi.emedha.in/pages/api/api/advertisements/${selectedAd.id}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                alert("Advertisement updated successfully!");
            } else {
                await axios.post("https://gwcapi.emedha.in/pages/api/api/advertisements", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                alert("Advertisement added successfully!");
            }
            closeModal();
            fetchAdvertisements();
        } catch (error) {
            console.error("Error saving advertisement:", error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this advertisement?")) {
            try {
                await axios.delete(`https://gwcapi.emedha.in/pages/api/api/advertisements/${id}`);
                alert("Advertisement deleted!");
                fetchAdvertisements();
            } catch (error) {
                console.error("Error deleting advertisement:", error);
            }
        }
    };

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = advertisements.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(advertisements.length / itemsPerPage);

    const handleBack = () => navigate(-1);
        const navigate = useNavigate();

    return (
        <>
        <div className="d-flex flex-column min-vh-100" style={{display: "flex", 
            flexDirection: "column", 
            background: "linear-gradient(135deg, #4B0082, #FFD700)", 
            color: "white" }}>


<div style={{ 
            minHeight: "100vh", }}>
            <Navbar className="dashboard-navbar p-3 shadow" style={{ backgroundColor: "#4B0082", }}>
                <Container fluid className="d-flex justify-content-between align-items-center">
                    <Navbar.Brand href="#" className="d-flex align-items-center">
                        <Image src={Logo} alt="Golden Women" className="logo-img1"  />
                    </Navbar.Brand>
                    <span className="brand-text">Golden Women</span>
                    <IoReturnUpBack className="text-white" size={30} style={{ cursor: "pointer" }} onClick={handleBack}/>
                </Container>
            </Navbar>
 

            {/* Main Content */}
            <div className="container mt-4 flex-grow-1">
                <h2 className="text-center mb-4">Advertisement Management</h2>

                {/* Add Advertisement Button */}
                <Button variant="success" className="mb-3" onClick={() => openModal()}>
                    <FaPlus /> Add Advertisement
                </Button>

                {/* Display Advertisements */}
                <div className="mt-4">
                    <h4>Existing Advertisements</h4>
                    <Table striped bordered hover variant="dark" className="shadow-sm">
    <thead>
        <tr>
            <th>#</th>
            <th>Category</th>
            <th>Image</th>
            <th>Actions</th>
        </tr>
    </thead>
    <tbody>
        {currentItems.map((ad, index) => (
            <tr key={ad.id}>
                <td>{indexOfFirstItem + index + 1}</td>
                <td>{ad.category}</td>
                <td>
                    <img
                        src={ad.image_url}
                        alt="Ad"
                        width="80"
                        height="50"
                        className="rounded"
                    />
                </td>
                <td>
                    <Button
                        variant="outline-info" size="sm"
                        className="me-2"
                        onClick={() => openModal(ad)}
                    >
                        <FaEdit /> 
                    </Button>
                    <Button
                        variant="outline-danger" size="sm"
                        onClick={() => handleDelete(ad.id)}
                    >
                        <FaTrash /> 
                    </Button>
                </td>
           
            </tr>
        ))}
    </tbody>
</Table>
                </div>

                {/* Pagination */}
      
                    <Pagination className="justify-content-center mt-3">
                        <Pagination.Prev
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        />
                        {[...Array(totalPages)].map((_, index) => (
                            <Pagination.Item
                                key={index}
                                active={currentPage === index + 1}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
    
            </div>
            </div>
            {/* Footer */}
            <footer className="text-center py-3 mt-auto" style={{ backgroundColor: "#4B0082", width: "100%" }}>
                <p className="mb-0 text-white">&copy; 2025 EMedha Technologies. All rights reserved.</p>
            </footer>
 
            </div>
            {/* Bootstrap Modal for Add/Edit Advertisement */}
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedAd ? "Edit Advertisement" : "Add Advertisement"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Select Page Route</label>
                            <select className="form-control" value={category} onChange={(e) => setCategory(e.target.value)}>
                                <option value="">Select Route</option>
                                <option value="advertise">Advertise Page</option>
                                <option value="login">Login</option>
                                <option value="signup">Signup</option>
                                <option value="index">Index</option>
                                <option value="welcome">Welcome</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Upload Image</label>
                            <input type="file" className="form-control" onChange={handleImageChange} />
                        </div>

                        <Button type="submit" variant="primary" className="w-100">
                            {selectedAd ? "Update Advertisement" : "Add Advertisement"}
                        </Button>
                    </form>
                </Modal.Body>
            </Modal>
            </>
    );
};

export default Advertisement;
